import { createContext, useContext, useState } from "react";
import { SortingDirection } from "@api/graphql/generated/generated-types";

export interface SelectedItem {
  id: string;
  label: string;
}

interface RouteTemplatesFiltersContextProps {
  searchTerm: string;
  setSearchTerm: (v: string) => void;
  driverIds: string[];
  setDriverIds: (v: string[]) => void;
  selectedEndCustomers: SelectedItem[];
  setSelectedEndCustomers: (v: SelectedItem[]) => void;
  orderLabelIds: string[];
  setOrderLabelIds: (v: string[]) => void;
  sortDirection: SortingDirection;
  setSortDirection: (v: SortingDirection) => void;
}

export const RouteTemplatesFiltersContext = createContext<
  RouteTemplatesFiltersContextProps | undefined
>(undefined);

export const RouteTemplatesFiltersProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [driverIds, setDriverIds] = useState<string[]>([]);
  const [selectedEndCustomers, setSelectedEndCustomers] = useState<SelectedItem[]>([]);
  const [orderLabelIds, setOrderLabelIds] = useState<string[]>([]);
  const [sortDirection, setSortDirection] = useState<SortingDirection>(
    SortingDirection.Asc
  );

  return (
    <RouteTemplatesFiltersContext.Provider
      value={{
        searchTerm,
        setSearchTerm,
        driverIds,
        setDriverIds,
        selectedEndCustomers,
        setSelectedEndCustomers,
        orderLabelIds,
        setOrderLabelIds,
        sortDirection,
        setSortDirection,
      }}
    >
      {children}
    </RouteTemplatesFiltersContext.Provider>
  );
};

export const useRouteTemplatesFiltersContext = () => {
  const context = useContext(RouteTemplatesFiltersContext);
  if (!context) {
    throw new Error(
      "useRouteTemplatesFiltersContext must be used within a RouteTemplatesFiltersProvider"
    );
  }
  return context;
};
